import { Component, ViewChild } from '@angular/core';
import { Queue } from '../../models/queue/queue.model';
import { Store, Select } from '@ngxs/store';
import { QueueState } from '../../store/queue/queue.state';
import { Observable } from 'rxjs';
import {
  DeleteBorrowerFromUserQueue,
  UpdateUserQueue,
  ClearUserQueue } from '../../store/queue/queue.actions';
import { QueueComponent } from '../queue/queue.component';

@Component({
  selector: 'app-queue-smart',
  templateUrl: './queue-smart.component.html',
  styleUrls: ['./queue-smart.component.scss']
})
export class QueueSmartComponent {

  @Select(QueueState.queue) queue$: Observable<Queue[]>;

  @ViewChild('queueComponent', { static: true })
    queueComponent: QueueComponent;

  constructor(private store: Store) { }

  handleDeleteBorrowerFromUserQueue(borrowerId: number) {
    this.store.dispatch(new DeleteBorrowerFromUserQueue(borrowerId));
  }

  handleUpdateQueue(updatedItem: { borrowerIndex: number, position: number }) {
    this.store.dispatch(new UpdateUserQueue(updatedItem.borrowerIndex, updatedItem.position));
  }

  handleClearUserQueue() {
    this.store.dispatch(new ClearUserQueue(true));
  }
}
